import { render, staticRenderFns } from "./sign-out.vue?vue&type=template&id=670f8893&scoped=true&lang=pug&"
import script from "./sign-out.vue?vue&type=script&lang=js&"
export * from "./sign-out.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670f8893",
  null
  
)

export default component.exports